import Breadcrumb from "@/components/feature/Breadcrumb";

function CharactersHeader() {
  return (
    <section className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "角色设定" }]} />
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-team-line"></i> 角色设定
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
            认识每一位让故事温暖起来的人
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            主角阿浩、青梅竹马小雨、导师老周，还有吉祥物嘿咻猫咪——嘿咻嘿咻漫画的每个角色都有属于自己的弧光。点开卡片，查看完整角色设定档案。
          </p>
        </div>
      </div>
    </section>
  );
}

export default CharactersHeader;